export const emailAddressGeneratorToolDefinition = {
    key: "email-address-generator",
    title: "Email Address Generator",
    summary: "Generate likely company email patterns from names plus one normalised domain.",
    accessScope: "balmoral-only",
    placements: ["hubspot-app-home", "sales-tools-dashboard", "record-side-panel"],
};
